<div class="carousel-datapurchase" *ngFor="let off of this.offers.offers; let i = index">
  <div *ngIf="this.index==i">
    <div id="slides_control" class="slides_web" *ngIf="off.offers[0].offersData.length!=0">
      <carousel interval="this.myInterval">
        <slide class="panelPaquetes" *ngFor="let offer of this.off.offers[0].offersData; let j = index">
          <div class="textData basicrow topbord-i allpads  f-reg roboto-r f-black text-justify"
               *ngIf="offer.offers.length==0">
            No hay planes sugeridos para este suscriptor.
          </div>
          <div class="slides_content pad-change-content" *ngIf="offer.offers.length > 0">
            <div class="caja-oferta padtop-data" *ngFor="let offerDet of offer.offers ; let k=index">
              <div class="basicrow caja-plan-sug">
                <div class="basicrow">
                  <div class="plandisptitle">
                    {{offerDet.DisplayName}}
                  </div>
                  <div class="plandispcont">
                    <div class="text-center">
                      Vigencia: Hasta el corte de ciclo.
                    </div>
                    <div class="basicrow roboto-r text-center">
                      <span class="f-big roboto-b">
                        {{offerDet.Price}}
                      </span>
                    </div>
                    <div class="basicrow text-center m-top">
                      <div class="servs-plans">
                        <div class="basicrow">
                          <a (click)="this.addOffers(offerDet.OfferId,offerDet.DisplayName,offerDet.Price,this.subscriber.groupIDField,this.subscriber.subscriberNumberField)"
                             class="btns red vcenter">
                            <span class="tabcell">
                              Comprar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</div>
